import { IStream } from "./IStream";
import { Log } from "./Log";
import { NamirasoftLogServer } from "./NamirasoftLogServer";

export class StreamNamirasoftLog implements IStream
{
    private queue: (() => Promise<void>)[] = [];
    private isProcessing = false;
    server: NamirasoftLogServer;
    user_id?: string;
    log_group_id: string;
    getProductID: () => (string | null);
    getWorkspaceID: () => (string | null);
    constructor(server: NamirasoftLogServer, log_group_id: string, getProductID: () => (string | null), getWorkspaceID: () => (string | null))
    {
        this.server = server;
        this.log_group_id = log_group_id;
        this.getProductID = getProductID;
        this.getWorkspaceID = getWorkspaceID;
    }
    write(log: Log, formated: { pre: string[], messages: string[], post: string[] }): void
    {
        if (process.env.NAMIRASOFT_STANDALNOE)
            return;
        let message = [...formated.pre, ...formated.messages, ...formated.post].join("\n");
        let body = {
            level: log.level.toString(),
            log_group_id: this.log_group_id,
            product_id: this.getProductID(),
            workspace_id: this.getWorkspaceID(),
            message
        };
        this.queue.push(async () =>
        {
            if (this.user_id)
                await this.server.log._CreateFor(this.user_id, body);
            else
                await this.server.log.Create(body);
        });
        this.processQueue();
    }
    private async processQueue()
    {
        if (this.isProcessing)
            return;
        this.isProcessing = true;
        try
        {
            while (this.queue.length > 0)
            {
                const job = this.queue.shift();
                if (job)
                {
                    try
                    {
                        await job();
                    }
                    catch (err)
                    {
                    }
                }
            }
        } finally
        {
            this.isProcessing = false;
        }
    }
}